export default "__VITE_ASSET__DW$C4_6N__"